import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { InvoiceSummary } from '@components';
import { InvoiceService } from '@services';
import utils from '@utils';
import { Loader } from '@components/common';

class InvoiceBreakDownTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading : false,
		};
	}

	shouldComponentUpdate = ({ invoice, timeZoneId }, { loading }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(invoice, lastProps.invoice)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
			|| !isEqual(loading, lastState.loading)
		);
	}

	/** Download Invoice PDF to users device */
	downloadInvoicePDF = () => {
		this.setState({ loading : true });
		const { invoice } = this.props;
		InvoiceService.downloadInvoicePDF({ id : invoice.Id })
			.then(({ data }) => {
				utils.downloadFromBlobResponse(data, `invoice_${invoice.Id}.pdf`);
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'The invoice download failed',
				});
			})
			.finally(() => this.setState({ loading : false }));
	}

	render() {
		const { invoice, timeZoneId } = this.props;
		const { loading } = this.state;
		return (
			<div className="invoice-details-div">
				<div className="margin-top-20 margin-bottom-20 flex">
					<span className="font-size-25 font-regular color-gray-deep-cove flex-1">Invoice Breakdown</span>
					<div className="invoice-breakdown-actions">
						<i
							className="rkfm rkfm-printer font-size-18 text-primary padding-top-5 cursor-pointer hidden-print print-icon"
							onClick={() => window.print()}
							onKeyPress={null}
							role="button"
							tabIndex={0}
							alt="print invoice"
						/>
						<If condition={loading}>
							<Loader active spinnerOnly size="small" className="margin-left-15 padding-top-5" />
						</If>
						<If condition={!loading}>
							<i
								className="rkfm rkfm-pdf font-size-18 text-primary padding-top-5 margin-left-15 cursor-pointer hidden-print pdf-icon"
								onKeyPress={null}
								role="button"
								tabIndex={0}
								alt="download invoice"
								onClick={() => this.downloadInvoicePDF()}
							/>
						</If>
					</div>

				</div>
				<div className="padding-horizontal-40 padding-xs-20">
					<div className="margin-top-50">
						<InvoiceSummary
							invoice={invoice}
							timeZoneId={timeZoneId}
							showDividers
						/>
					</div>
				</div>
			</div>
		);
	}
}

InvoiceBreakDownTable.propTypes = {
	invoice    : PropTypes.object,
	timeZoneId : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};

InvoiceBreakDownTable.defaultProps = {
	invoice    : {},
	timeZoneId : '',
};

export default InvoiceBreakDownTable;
